export enum ScreeningsSortBy {
  Title = 'title',
  Time = 'time',
}
